import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchFailureAnalysisPrefill = async (tcid) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "failureAnalysis",
    companyId: user.companyid,
    tcid,
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`,
  );
  return response.data;
};

const useFailureAnalysisPrefillQuery = (tcid, enabled) => {
  return useQuery({
    queryKey: ["failureAnalysisPrefill", tcid],
    queryFn: () => fetchFailureAnalysisPrefill(tcid),
    enabled: !!tcid && !!enabled,
    refetchOnWindowFocus: false,
  });
};

export default useFailureAnalysisPrefillQuery;